import { createFileRoute } from "@tanstack/react-router";
import {
	formTabSearch,
	redirectLegacyEntityTypeForm,
} from "@/features/form-editor/lib/redirect-legacy-entity-type-form";

const ROUTE_ID =
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/assetTypes/$assetTypeId/full/form" as const;

export const Route = createFileRoute(ROUTE_ID)({
	beforeLoad: ({ location, params, search }) => {
		redirectLegacyEntityTypeForm({
			pathname: location.pathname,
			typeId: params.assetTypeId,
			to: "/org-admin/$orgId/configuration/assetTypes/$assetTypeId/full",
			params: { orgId: params.orgId, assetTypeId: params.assetTypeId },
			search: formTabSearch(search),
		});
	},
	component: () => null,
});
